import React, { useEffect, useMemo, useRef } from "react"

import { Table, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import Button from "../Button"
import Private from "../Private"

//import EmptyComponent from '../Empty'

import "./styles.less"

const { Text } = Typography

export const itemRender = (_, type, originalElement, t) => {
  if (type === "prev") {
    return <Button className="ant-pagination-item-link1">{t("Previous")}</Button>
  }
  if (type === "next") {
    return <Button className="ant-pagination-item-link1">{t("Next")}</Button>
  }
  return originalElement
}

const TableComponent = ({
  loading,
  dataSource,
  pagination,
  withOutPagination,
  showSizeChanger,
  rowKey,
  onScroll,
  next,
  hoverMarker,
  emptyType,
  className,
  EmptyComponent,
  scroll,
  headerDataTour,
  columns,
  ...props
}) => {
  const { t } = useTranslation()
  const tableRef = useRef(null)

  // A column opts in with `sensitive: true` instead of every column.js hand-wrapping its own
  // render in <Private> - untouched for any column without the flag, so this is purely additive.
  const processedColumns = useMemo(
    () =>
      columns?.map((col) =>
        !col?.sensitive
          ? col
          : {
              ...col,
              render: (value, record, index) => (
                <Private>{col.render ? col.render(value, record, index) : value}</Private>
              )
            }
      ),
    [columns]
  )

  useEffect(() => {
    if (!onScroll) return
    const tableElement = tableRef?.current?.nativeElement
    let tableBody = null
    if (tableElement) {
      tableBody = tableElement.querySelector(".ant-table-body")
      if (tableBody && next) {
        tableBody.addEventListener("scroll", onScroll)
      }
    }
    return () => {
      if (tableBody) tableBody.removeEventListener("scroll", onScroll)
    }
  }, [tableRef, next])

  useEffect(() => {
    if (!headerDataTour) return
    const tableElement = tableRef?.current?.nativeElement
    const headerElement =
      tableElement?.querySelector(".ant-table-header") ||
      tableElement?.querySelector(".ant-table-thead")
    headerElement?.setAttribute("data-tour", headerDataTour)
  }, [tableRef, headerDataTour, columns])

  useEffect(() => {
    if (hoverMarker) {
      tableRef?.current?.scrollTo({ key: hoverMarker })
    }
  }, [hoverMarker])

  return (
    <Table
      ref={tableRef}
      id="custom-table"
      className={cls("custom-table", className)}
      rowKey={(record) => record[rowKey || "id"]}
      loading={loading}
      dataSource={dataSource}
      columns={processedColumns}
      showSorterTooltip={false}
      rowHoverable={false}
      // scroll={{x: 1300}}
      scroll={scroll ? scroll : { x: 1300 }}
      pagination={
        !dataSource?.length || withOutPagination
          ? false
          : {
              position: ["none", "bottomRight"],
              showLessItems: true,
              showSizeChanger: showSizeChanger,
              //pageSizeOptions: [1,2,3],
              itemRender: (_, type, originalElement) =>
                pagination?.pageSize >= pagination?.total
                  ? null
                  : itemRender(_, type, originalElement, t),
              showTotal: (total, range) => (
                <Text>
                  Showing <Text strong>{`${range[0]}-${range[1]} of ${total}`}</Text> results
                </Text>
              ),
              ...pagination
            }
      }
      locale={EmptyComponent ? { emptyText: <EmptyComponent /> } : undefined}
      {...props}
    />
  )
}

export default React.memo(TableComponent)
